import { motion } from 'framer-motion';
import { Container } from '@/components/ui/container';
import { services } from '@/data/services';

export default function LandingServices(): JSX.Element {
	return (
		<Container>
			<div className="text-center mb-12">
				<h2 className="text-3xl md:text-4xl font-bold mb-4 font-space-grotesk">
					What You Get With a Fractional CTO
				</h2>
				<p className="text-muted-foreground text-lg max-w-3xl mx-auto">
					With over a decade leading digital projects for both major enterprises and local small
					businesses, I bring that same strategic oversight to every client. As your
					fractional CTO, I evaluate, build, and manage across four pillars — so your tech evolves
					alongside your business instead of piling up as one-off projects.
				</p>
			</div>
			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
				{services.map((service, index) => (
					<motion.div
						key={service.title}
						initial={{ scale: 0.98, y: 5 }}
						animate={{ scale: 1, y: 0 }}
						transition={{
							duration: 0.2,
							delay: index * 0.05,
							ease: 'easeOut',
						}}
						whileHover={{
							y: -8,
							scale: 1.02,
							transition: { duration: 0.2 },
						}}
						className="space-card p-6 sm:p-8 rounded-xl flex flex-col min-h-[320px] relative group transition-all duration-300"
					>
						<div className="absolute inset-0 rounded-xl bg-gradient-to-br from-orange-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
						<div
							className={`w-12 h-12 sm:w-14 sm:h-14 rounded-full mb-5 sm:mb-6 flex items-center justify-center bg-orange-500/10 mx-auto group-hover:scale-110 transition-transform duration-300`}
						>
							<service.icon className="w-6 h-6 sm:w-7 sm:h-7 text-red-500" />
						</div>
						<h3 className="text-xl sm:text-2xl font-bold mb-3 font-space-grotesk break-words text-center">
							{service.title}
						</h3>
						<p className="text-muted-foreground text-base sm:text-lg mb-6 flex-grow text-center">
							{service.description}
						</p>
					</motion.div>
				))}
			</div>
		</Container>
	);
}
